// src/components/PostHogProvider.tsx
"use client";

import { Suspense, useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import {
  captureInitialUtm,
  initPostHog,
  trackPageview,
} from "@/lib/analytics";

// Init a nivel de módulo: el provider se carga antes de cualquier child, así
// que cuando `<PostHogPageView>` corre su useEffect (después de los effects de
// los hijos) PostHog ya está inicializado. Hacerlo en useEffect del provider
// pierde el primer pageview porque los effects de los hijos corren primero.
if (typeof window !== "undefined") {
  initPostHog();
}

function PostHogPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!pathname) return;
    const sp = new URLSearchParams(searchParams?.toString() ?? "");
    captureInitialUtm(sp);
    trackPageview(window.location.href);
  }, [pathname, searchParams]);

  return null;
}

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Suspense fallback={null}>
        <PostHogPageView />
      </Suspense>
      {children}
    </>
  );
}
